import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Mastercard-logo@2x.png")